import './ModerateError.less';

import React, { FC } from 'react';
import InfoCircleIcon from '../../../icons/svg/info-circle-icon-sv.svg';

interface ModerateErrorProps {
    text: string;
    children?: FC;
}

const ModerateError: FC<ModerateErrorProps> = ({ text, children }) => (
    <div className="nui-moderate-error flex px-10 py-10 items-center br-radius-xs">
        <InfoCircleIcon />
        <div className="flex c-black-50-2 fs-14 pl-10 items-center">{text}</div>
        {children}
    </div>
);
export default ModerateError;
